type LogScope =
  | 'WEBSOCKET-MANAGER'
  | 'NETWORK-CONNECTIVITY'
  | 'SHARED-WORKER'
  | 'AUTH'
  | 'WS-HEALTH-CHECK';

export function debugLog(
  scope: LogScope,
  message: string,
  extra?: Record<string, unknown>,
): void {
  const time = new Date().toLocaleString('de-de', {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    fractionalSecondDigits: 3,
  });

  const args: unknown[] = [`${time} [${scope}] ${message}`];
  if (extra) args.push(extra);

  console.log(...args);
}
